module.exports = __webpack_public_path__ + "static/media/SC_H_04.8f21f1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/faces/SC_H_04.png
// module id = 175
// module chunks = 0